import { motion } from "framer-motion";

type ProcessingState = "thinking" | "fetching" | "writing" | null;

type ProcessingIndicatorProps = {
  state: ProcessingState;
};

const ProcessingIndicator = ({ state }: ProcessingIndicatorProps) => {
  if (!state) return null;

  return (
    <motion.div
      key="processing"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="flex justify-start"
    >
      <div className="bg-accent/10 text-white rounded-lg p-4">
        {state === "thinking" && "Thinking..."}
        {state === "fetching" && "Fetching invoice..."}
        {state === "writing" && "Writing..."}
      </div>
    </motion.div>
  );
};

export default ProcessingIndicator;